import RoomPageBase from './room-page-base'

export default class OrionsRevengeOnlinePage extends RoomPageBase {}

OrionsRevengeOnlinePage.init()
